/**
 * AA Store Theme JavaScript (slimmed 2026-06: the header/menu/search/cart-drawer
 * and predictive-search blocks targeted selectors that existed in no template
 * and were removed with the legacy sections. prototype-nav.js / prototype-cart.js
 * own those surfaces now.)
 * Live here: cart-page quantity handling + smooth scroll + entrance animations.
 */

document.addEventListener('DOMContentLoaded', function() {
  function formatMoney(cents) {
    var currencyCode = 'USD';
    try {
      if (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) {
        currencyCode = window.Shopify.currency.active;
      }
    } catch (e) { /* use default */ }
    return (cents / 100).toLocaleString(undefined, {
      style: 'currency',
      currency: currencyCode
    });
  }

  // Cart page quantity buttons
  var cartItems = document.querySelectorAll('.cart-item');
  cartItems.forEach(function(item) {
    var key = item.dataset.key;
    var decreaseBtn = item.querySelector('[data-action="decrease"]');
    var increaseBtn = item.querySelector('[data-action="increase"]');
    var removeBtn = item.querySelector('[data-action="remove"]');
    var qtyValue = item.querySelector('.cart-item__qty-value');

    if (decreaseBtn) {
      decreaseBtn.addEventListener('click', function() {
        var currentQty = parseInt(qtyValue.textContent);
        // Minus at quantity 1 removes the line (the previous silent no-op
        // read as a broken button on mobile).
        updateCartItem(key, currentQty - 1);
      });
    }

    if (increaseBtn) {
      increaseBtn.addEventListener('click', function() {
        var currentQty = parseInt(qtyValue.textContent);
        updateCartItem(key, currentQty + 1);
      });
    }

    if (removeBtn) {
      removeBtn.addEventListener('click', function() {
        updateCartItem(key, 0);
      });
    }
  });

  function showCartNotification(message) {
    var notification = document.querySelector('.cart-notification');
    if (!notification) {
      notification = document.createElement('div');
      notification.className = 'cart-notification';
      notification.style.cssText = 'position:fixed;bottom:20px;left:50%;transform:translateX(-50%);background:#1A1A1A;color:#F5F0E8;padding:12px 24px;font-size:14px;z-index:9999;letter-spacing:0.05em;';
      document.body.appendChild(notification);
    }
    notification.textContent = message;
    notification.style.display = 'block';
    setTimeout(function() { notification.style.display = 'none'; }, 3000);
  }

  function updateCartItem(key, quantity) {
    var cartItem = document.querySelector('[data-key="' + key + '"]');
    if (cartItem) cartItem.style.opacity = '0.5';

    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id: key,
        quantity: quantity
      })
    })
    .then(function(response) {
      if (!response.ok) {
        return response.json().then(function(err) {
          throw new Error(err.description || 'Could not update cart');
        });
      }
      return response.json();
    })
    .then(function(cart) {
      if (quantity === 0 && cartItem) {
        cartItem.style.transition = 'opacity 0.2s ease, max-height 0.3s ease';
        cartItem.style.opacity = '0';
        cartItem.style.maxHeight = cartItem.offsetHeight + 'px';
        setTimeout(function() { cartItem.style.maxHeight = '0'; cartItem.style.paddingBottom = '0'; cartItem.style.overflow = 'hidden'; }, 10);
        setTimeout(function() { cartItem.remove(); }, 350);
      } else if (cartItem) {
        var qtyEl = cartItem.querySelector('.cart-item__qty-value');
        var totalEl = cartItem.querySelector('.cart-item__total');
        var lineItem = cart.items.find(function(i) { return i.key === key; });
        // Render the SERVER-confirmed quantity: /cart/change.js silently caps at
        // available inventory, and the page must never show more than checkout will charge.
        var confirmedQty = lineItem ? lineItem.quantity : quantity;
        if (qtyEl) qtyEl.textContent = confirmedQty;
        if (totalEl && lineItem) totalEl.textContent = formatMoney(lineItem.final_line_price);
        cartItem.style.opacity = '1';
        if (lineItem && quantity > 0 && lineItem.quantity < quantity) {
          showCartNotification('Only ' + lineItem.quantity + ' available.');
        }
      }

      // Update subtotal (shop money format, not hardcoded USD) and the bag badge
      var subtotalEl = document.querySelector('.cart-summary__row span:last-child');
      if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
      if (window.Bag && window.Bag.refresh) {
        window.Bag.refresh();
      } else if (typeof updateCartCount === 'function') {
        updateCartCount(cart.item_count);
      }

      // If cart is empty, reload to show empty state
      if (cart.item_count === 0) {
        setTimeout(function() { window.location.reload(); }, 400);
      }
    })
    .catch(function(error) {
      console.error('Error updating cart:', error);
      if (cartItem) cartItem.style.opacity = '1';
      showCartNotification(error.message || 'Something went wrong. Please try again.');
    });
  }

  // Smooth scroll for anchor links
  document.querySelectorAll('a[href^="#"]').forEach(function(anchor) {
    anchor.addEventListener('click', function(e) {
      var href = this.getAttribute('href');
      if (href.length > 1) {
        e.preventDefault();
        var target = document.querySelector(href);
        if (target) {
          target.scrollIntoView({
            behavior: 'smooth'
          });
        }
      }
    });
  });

  // Entrance animations via IntersectionObserver
  var animateEls = document.querySelectorAll('.animate-on-scroll');
  if (animateEls.length && 'IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

    animateEls.forEach(function(el) { observer.observe(el); });
  } else {
    animateEls.forEach(function(el) { el.classList.add('is-visible'); });
  }
});
